import React, { Fragment, useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import CardBody from 'components/Card/CardBody';
import Button from 'components/CustomButtons/Button.js';
import moment from 'moment';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import {
  Assignment,
  Cancel,
  CheckCircle,
  Delete,
  Map,
  OpenInBrowser,
  RadioButtonChecked,
  RadioButtonUnchecked
} from '@material-ui/icons';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import { WithApp } from 'contexts/appContext';
import { currency } from 'hooks/Pipe';
import { Toasty, useToasty } from 'hooks/Toasty';
import { wsUpdate, wsGet } from 'services/WService';
import { IconButton, Tooltip } from '@material-ui/core';
import TrasingModal from '../TracingBoss/TrasingModal';
import stateLiquidation from 'hooks/stateLiquidation';
import { wsCreate } from 'services/WService';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  containBox: {
    maxHeight: '160px',
    overflowY: 'auto',
    '&::-webkit-scrollbar-track': {
      borderRadius: '10px'
    },
    '&::-webkit-scrollbar': {
      width: '7px',
      backgroundColor: '#f1f1f1'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#d5d5d9',
      borderRadius: '10px'
    },
    '&::-webkit-scrollbar:horizontal': {
      display: 'none'
    }
  },
  work: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '16px',
    fontWeight: 'bold',
    borderBottom: '1px solid gray',
    paddingBottom: '4px',
    marginBottom: '4px'
  },
  state: {
    fontSize: '12px',
    padding: '0px 5px 0px 5px',
    backgroundColor: '#4CAF50',
    borderRadius: 5,
    color: 'white',
    height: 20
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: '#HR', accessor: 'codprog', width: 80, align: 'center' },
  { Header: 'Documento', accessor: 'numero', width: 130, align: 'center' },
  { Header: 'Cod. Cliente', accessor: 'cardcode', width: 120, align: 'center' },
  { Header: 'Nombre Cliente', accessor: 'cardname' },
  { Header: 'Dirección', accessor: 'address' },
  { Header: 'Estado Doc.', accessor: 'docstatus', width: 120, align: 'center' },
  { Header: 'Fecha Liq.', accessor: 'fecusu', width: 140, align: 'center' },
  { Header: 'Estado Liq.', accessor: 'liqstatus', width: 120, align: 'center' },
  { Header: 'Monto', accessor: 'sumapply', width: 120, align: 'right' },
  { Header: 'Total Doc', accessor: 'doctotal', width: 120, align: 'right' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function WorkingBossShow(props) {
  const classes = useStyles();
  const { id } = useParams();
  const [notify, showNotify] = useToasty();

  const [data, setData] = useState({ jornadas: [] });
  const [work, setWork] = useState(0);
  const [sheet, setSheet] = useState(0);
  const [openMap, setOpenMap] = useState({ show: false, data: {} });
  const [jornada, setJornada] = useState({});
  const [zoneId, setZoneId] = useState();

  async function listDatas() {
    let response = await wsGet('deliv/usuario', id);
    if (response.success) {
      const jornadas = response.data?.jornadas.map((jn) => {
        const hojas = jn.hojas.map((hr) => {
          const documentos = hr.documentos.map((doc) => {
            return { ...doc, state_hr: hr.state };
          });
          return { ...hr, documentos };
        });
        return { ...jn, hojas };
      });

      setZoneId(response.data.base_zone_id);
      setData({ ...response.data, jornadas });
    }
  }

  async function updateDocument(doc) {
    let response = await wsUpdate('deliv/document', doc.docentry, { docstatus: 'O' });
    if (response.success) {
      showNotify(response.message);
      listDatas();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    listDatas();
    return () => setData({ jornadas: [] });
  }, []);

  return (
    <Fragment>
      <Toasty action={notify} />

      {/* {!openMap.show ? undefined : (
        <TracingBoss openMap={openMap} onClose={() => setOpenMap({ show: false, data: {} })} />
      )} */}

      {!openMap.show ? undefined : (
        <TrasingModal
          open={openMap.show}
          onClose={() => setOpenMap({ show: false })}
          zoneId={zoneId}
          jornada={jornada}
        />
      )}

      <Card style={{ marginBottom: '40px' }}>
        <CardBody>
          <span style={{ fontWeight: 'bold', fontSize: '15px' }}>
            {data.codusu} - {data.nombre}
          </span>
          <hr style={{ margin: 1 }} />
          <GridContainer>
            <GridItem xs={4}>
              <GridContainer className={classes.containBox}>
                {data.jornadas.map((item, i) => (
                  <ListWork
                    key={i}
                    item={item}
                    i={i}
                    work={work}
                    setWork={setWork}
                    setOpenMap={setOpenMap}
                    setJornada={setJornada}
                  />
                ))}
              </GridContainer>
            </GridItem>
            <GridItem xs={8}>
              <GridContainer className={classes.containBox}>
                {data.jornadas[work]?.hojas.map((item, i) => (
                  <ListSheet
                    key={i}
                    item={item}
                    i={i}
                    sheet={sheet}
                    setSheet={setSheet}
                    userId={id}
                    showNotify={showNotify}
                    reload={listDatas}
                  />
                ))}
              </GridContainer>
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>

      {data?.jornadas[work]?.hojas[sheet]?.documentos.length === 0 ? undefined : (
        <Card>
          <CardHeader icon>
            <CardIcon pointer="true" color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado de documentos</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName={`documentos de jornada ${data.nombre}`}
              formatDate="DD-MM-YYYY HH:mm:ss"
              defaultWidth={1500}
              columns={columns}
              data={
                data?.jornadas[work]?.hojas[sheet]?.documentos?.map((item, i) => {
                  return {
                    num: (
                      <div className="actions-right">
                        {i + 1}
                        <Tooltip title="Re-abrir">
                          <span>
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => updateDocument(item)}
                              disabled={item.docstatus === 'O' || item.state_hr !== 'W'}
                            >
                              <OpenInBrowser />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </div>
                    ),
                    codprog: item.codprog,
                    numero: item.numero,
                    cardcode: item.cardcode,
                    cardname: item.cardname,
                    address: item.address,
                    docentry: item.docentry,
                    docstatus: item.docstatus === 'O' ? 'Abierto' : 'Cerrado',
                    fecusu: item.fecusu,
                    liqstatus:
                      item.liqstatus == '0'
                        ? 'Completo'
                        : item.liqstatus == '1'
                        ? 'Anulado'
                        : item.liqstatus == '2'
                        ? 'Parcial'
                        : 'Otros',
                    doctotal: currency(item.doctotal),
                    sumapply: currency(item.sumapply),
                    actions: '',
                  };
                }) || []
              }
            />
          </CardBody>
        </Card>
      )}
    </Fragment>
  );
});

const ListWork = ({ item, i, work, setWork, setOpenMap, setJornada }) => {
  const classes = useStyles();

  const showMap = () => {
    const documents = [];
    for (let hr of item.hojas) {
      for (let doc of hr.documentos) {
        if ((doc.refy != '0' || doc.refy != '') && doc.docstatus === 'C')
          documents.push({ ...doc });
      }
    }
    setOpenMap({ show: true, data: { idWork: item.id, documents } });
    setJornada(item);
  };

  return (
    <GridItem xs={12}>
      <Card
        style={{
          fontWeight: '400',
          cursor: 'pointer',
          backgroundColor: i === work ? '#e9ffec' : 'white',
          margin: 10
        }}
        onClick={() => setWork(i)}
      >
        <CardBody>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button onClick={showMap} color="info" justIcon style={{ marginRight: 10 }}>
              <Map />
            </Button>
            <div style={{ width: '100%' }}>
              <div className={classes.work}>
                <span>Jornada del : {moment(item.dia).format('DD-MM-YYYY')}</span>
                <span className={classes.state}>{item.estado === 'O' ? 'Abierto' : 'Cerrado'}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ display: 'flex', alignItems: 'center', color: '#4CAF50' }}>
                  <CheckCircle style={{ fontSize: 16 }} />{' '}
                  {moment(item.hora_apertura).format('L LT')}
                </span>
                <span style={{ display: 'flex', alignItems: 'center', color: '#4CAF50' }}>
                  P.Liq.: {item.primera_liquidacion !== null ? moment(item.primera_liquidacion).format('LT') : '-'}
                </span>
                <span style={{ display: 'flex', alignItems: 'center', color: 'red' }}>
                  <Cancel style={{ fontSize: 16 }} />{' '}
                  {item.hora_cierre ? moment(item.hora_cierre).format('LT') : '-/-/-'}
                </span>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </GridItem>
  );
};

const ListSheet = ({ item, i, sheet, setSheet, userId, showNotify, reload }) => {
  async function removeSheet() {
    let confirm = window.confirm('Seguro de eliminar la hoja?');
    if (confirm === false) return;

    let res = await wsCreate('deliv/usuario/remove-distribution', {
      codusu: userId,
      jornada_id: item.jornada_id,
      prog_sheet_distribution_id: item.prog_sheet_distribution_id,
    });
    if (res.success) {
      showNotify(res.message);
      reload();
    } else {
      showNotify(res.message, 'error');
    }
  }

  return (
    <GridItem xs={12} md={3} lg={3} xl={3}>
      <Card
        style={{
          fontWeight: '400',
          cursor: 'pointer',
          backgroundColor: i === sheet ? '#e9ffec' : 'white',
        }}
        onClick={() => setSheet(i)}
      >
        <CardBody>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {i === sheet ? <RadioButtonChecked /> : <RadioButtonUnchecked />}

            <b>
              {item.prog_sheet_distribution_id} - {stateLiquidation(item.state)}
            </b>
            <AllowedGuard permission={ConstantPermissions.DELIV_JORNADAS_INICIAR_JORNADA}>
              <Button justIcon round simple color="danger" onClick={removeSheet}>
                <Delete />
              </Button>
            </AllowedGuard>
          </div>
        </CardBody>
      </Card>
    </GridItem>
  );
};
